<template>
	<v-footer color="primary" dark padless class="footer">
		<div class="footer-background-color"></div>

		<!-- REDACTED  -->
		<v-row dense class="footer-container ma-0 pt-5" justify="space-around"
			:style="{ 'padding': leftMenuBarTrigger ? '0px 0px 0px 250px' : '0px 20px 0px 20px' }">
			<!-- FIRST COLUMN -->
			<v-col :cols="mobile ? 12 : 3" class="pt-15 pb-5 px-0">
				<v-row class="ma-0" justify="center" align="end">
					<router-link to="/" class="ma-0">
						<img v-bind:src="BrebLogo" :width="mobile ? 200 : 240" />
					</router-link>
				</v-row>
				<v-row class="ma-0" justify="center" :style="{ 'font-size': mobile ? '20px' : '22px' }">
					<!-- Digital Media Company -->
					<span class="color-yellow">D</span>igital&nbsp;
					<span class="color-yellow">M</span>edia&nbsp;
					<span class="color-yellow">C</span>ompany
				</v-row>
			</v-col>
			<v-col v-show="false" cols="auto">
				<BrebAutocompleteLocation ref="brebAutocompleteLocation" @disableLoading="disableLoading" rounded
					:value="searchedCity" @placechanged="setLocation" class="mb-4" />
			</v-col>

			<!-- SECOND COLUMN -->
			<v-col :cols="mobile ? 12 : 6" class="pt-5 pb-5 px-0">
				<v-row class="ma-0 pb-3" justify="center">
					<v-col cols="auto" class="pa-2" style="border-radius: 5px; border: 1px solid yellow; color: yellow;"
						:style="{ 'font-size': mobile ? '20px' : '22px' }">
						Resources & Directory
					</v-col>
				</v-row>
				<v-row v-if="!mobile" class="ma-0">
					<v-col class="pa-0" :cols="6">
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('merchant')">
									<span class="page-body resources">Best Supplies & Services</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('city_service')">
									<span class="page-body resources">Municipal Service Directory</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('property')">
									<span class="page-body resources">Real Estate & Rental Listings</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('event')">
									<span class="page-body resources">Real Estate Related Events</span>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-col class="pa-0" :cols="6">
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('item')">
									<span class="page-body resources">Buy & Sell - Marketplace</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('classified')">
									<span class="page-body resources">Trade/Jobs & Opportunities</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('brokerage')">
									<span class="page-body resources">Real Estate Brokerages</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<!-- <router-link to=""> -->
								<v-btn text x-small rounded @click="clickResource('realtor')">
									<span class="page-body resources">Real Estate Agents/Reps</span>
								</v-btn>
								<!-- </router-link> -->
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row v-else class="ma-0">
					<v-col class="pa-0" :cols="12">
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('merchant')">
									<span class="page-body resources">Best Supplies & Services</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('item')">
									<span class="page-body resources">Buy & Sell - Marketplace</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('city_service')">
									<span class="page-body resources">Municipal Service Directory</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('property')">
									<span class="page-body resources">Real Estate & Rental Listings</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('brokerage')">
									<span class="page-body resources">Real Estate Brokerages</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('realtor')">
									<span class="page-body resources">Real Estate Agents/Reps</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('event')">
									<span class="page-body resources">Real Estate Related Events</span>
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="ma-0">
							<v-col class="text-center" :class="mobile ? 'py-1' : 'py-2'">
								<v-btn text x-small rounded @click="clickResource('classified')">
									<span class="page-body resources">Trade/Jobs & Opportunities</span>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>

			<!-- THIRD COLUMN -->
			<v-col :cols="mobile ? 12 : 3" class="pt-5 pb-10 px-0">
				<v-row class=" ma-0 ma-0" justify="center">
					<v-col class="pt-5 pb-0" cols="auto">
						<router-link to="/policy/privacyPolicy">
							<v-btn text x-small rounded>
								<span class="page-body resources" style="color: white;">Privacy Policy</span>
							</v-btn>
						</router-link>
					</v-col>
				</v-row>
				<v-row class="ma-0" justify="center">
					<v-col class="pt-0" cols="auto">
						<router-link to="/policy/termsAndUse">
							<v-btn text x-small rounded>
								<span class="page-body resources" style="color: white;">Terms of Use</span>
							</v-btn>
						</router-link>
					</v-col>
				</v-row>

				<v-row class="ma-0">
					<v-col class="pa-0 page-body" :style="{ 'font-size': mobile ? '20px' : '22px' }"
						style="color: white;">
						Follow us:
					</v-col>
				</v-row>
				<v-row class="ma-0 follow-social-container">
					<v-col class="follow-social-icons">
						<v-btn icon target="_blank" href="https://twitter.com/MyBREB">
							<!-- <v-icon  size="40">mdi-twitter </v-icon> -->
							<v-img src="@/assets/brand/twitter-x-icon.png" width="36" height="36"
								style="display: inline-flex; vertical-align: middle;"></v-img>
						</v-btn>
					</v-col>
					<v-col class="follow-social-icons">
						<v-btn icon target="_blank" href="https://www.facebook.com/profile.php?id=100092500433436">
							<v-icon size="40">mdi-facebook</v-icon>
						</v-btn>
					</v-col>
					<v-col class="follow-social-icons">
						<v-btn icon>
							<v-icon size="40">mdi-linkedin</v-icon>
						</v-btn>
					</v-col>
					<v-col class="follow-social-icons">
						<v-btn icon target="_blank" href="https://www.instagram.com/bestrealestatebuydotcom/">
							<v-icon size="40">mdi-instagram</v-icon>
						</v-btn>
					</v-col>
				</v-row>

				<v-row class="ma-0">
					<v-col class="pa-0 page-body" style="color: white;">
						Copyright © 2025 Best Real Estate Buy
					</v-col>
				</v-row>
				<v-row class="ma-0">
					<v-col class="pa-0 page-body" style="color: white;">
						All rights reserved
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<BrebLoading :loading="loading" />
	</v-footer>
</template>

<script>
import BrebLogo from "@/assets/breb.rect.logo.new.png";
import BrebAutocompleteLocation from '@/components/accessory/BrebAutocompleteLocation.vue';
import debounce from 'lodash/debounce';
import { cityProfileSample } from "@/settings/cityProfileSamples";
import BrebLoading from '@/components/accessory/BrebLoading.vue';

export default {
	name: "PersistentFooter",
	components: {
		BrebAutocompleteLocation,
		BrebLoading,
	},
	props: {
		leftMenuBarTrigger: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			BrebLogo,
			searchedCity: null,
			category: null,
			subcategory: null,
			loading: false,
		};
	},
	computed: {
		mobile() {
			return this.$vuetify.breakpoint.mobile
		},
		cellphone() {
			return this.$vuetify.breakpoint.xs
		},
		subcategoryItems: function () {
			return this.$store.getters['getType'](this.category)
		},
		cityProfileSample() {
			return cityProfileSample;
		},
	},
	watch: {
		searchedCity: {
			deep: true,
			handler() {
				this.searchResource();
			},
		},
		'category': {
			deep: true,
			handler(v) {
				if (v !== 'brokerage') {
					this.subcategory = this.subcategoryItems[0].value;
				} else {
					this.subcategory = null;
				}
			}
		}
	},
	methods: {
		async clickResource(type) {
			this.loading = true;
			this.category = type;
			this.$refs.brebAutocompleteLocation.getGeolocation();
		},
		searchResource: debounce(function () {
			if (this.category === 'city_service') {
				this.navigateToSeeDemo();
			} else if (this.category === 'brokerage') {
				this.$router.push({
					name: 'SearchBrokerage',
					query: {
						page: '0',
						size: '10',
						lat: this.searchedCity.lat,
						lng: this.searchedCity.lng,
						formattedAddress: this.searchedCity.formatted_address,
					}
				})
			} else {
				let q = {
					category: this.category,
					subcategory: this.subcategory,
					query: {
						lat: this.searchedCity.lat,
						lng: this.searchedCity.lng,
						formattedAddress: this.searchedCity.formatted_address,
					},
				};
				this.$store.dispatch("search/performQueryRouting", q);
			}
			this.loading = false;
		}, 200),
		navigateToSeeDemo() {
			this.$router.push({
				name: 'CityServiceListingView', params: {
					id: -1,
					previewListing: this.cityProfileSample
				}
			});
		},
		setLocation(addressData) {
			if (addressData) {
				this.searchedCity = {
					lat: addressData.point.lat,
					lng: addressData.point.lng,
					formatted_address: addressData.fullAddress,
				};
			} else {
				this.searchedCity = null
			}
		},
		disableLoading() {
			this.loading = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables.scss";
@import "../globals";
@media only screen and (max-width: "1010px") {}

.footer {
	justify-content: center;
	min-height: 300px;
	background: url("../assets/footerNav/toronto.png") center center/cover no-repeat;
}

.footer-background-color {
	min-width: 100%;
	min-height: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	background-color: #0b4173af;
	z-index: 1;
}

.footer-container {
	z-index: 2;
}

.follow-social-container {
	display: flex;
	justify-content: center;
}

.follow-social-icons {
	display: flex;
	justify-content: center;
	max-width: 50px;
}

.follow-social-icons i {
	color: #fff !important;
}

.resources {
	color: yellow;
	font-weight: normal;
	text-transform: capitalize;
}
</style>
